export const companyTypes = {
  CRUSHER: "CRUSHER",
  MINES: "MINES",
  "CONSTRUCTION COMPANY": "CONSTRUCTION COMPANY",
  "INDEPENDENT CONTRACTOR": "INDEPENDENT CONTRACTOR",
  OTHER: "OTHER",
};

export const userRoles = {
  COMPANY_ADMIN: "COMPANY_ADMIN",
  COMPANY_EDITOR: "COMPANY_EDITOR",
  COMPANY_VIEWER: "COMPANY_VIEWER",
  DEFAULT_USER: "DEFAULT_USER",
};

export const localStoreConfig = {
  mobileNumber: "mobileNumber",
  secureToken: "secureToken",
};

export const formModes = {
  create: "create",
  update: "update",
};

export const daysMode = {
  day: 1,
  week: 7,
  month: 30,
};

export const reportXAxisMode = {
  daily: "daily",
  weekly: "weekly",
  monthly: "monthly",
};

export const verificationStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
};
